export default "__VITE_ASSET__fbc6f141__"